module.exports = {
  loading: 'ලෝඩ් වෙමින්...',
  logout: 'පිටවන්න',
  logoutDesc: 'ඔබට ඇත්තෙන්ම පිටවීමට අවශ්‍යද?',
  check: 'පරීක්ෂා කරන්න',
  asntitle: 'QUizZZ වේලාව',
  asntitle2: 'ඉතිරි ප්‍රශ්න',
  Correct: 'නිවැරදි',
  wrong: 'වැරදි',
  ansTitle1: 'අතිශයින් හොඳයි!',
  ansTitle2: 'ඔබට තවමත් ',
  ansTitle22: 'මෙම වැරදි පිළිතුර සඳහා කාඩ් එකක් ලැබුණා!',
  ansTitle3: 'ඉතා සමීපයි!',
  congratulations: 'සුභ පැතුම්!',
  otp: 'OTP',
  ladingpageTips: '(ජනවාරි 9 සිට පෙබරවාරි 7 දක්වා නොමිලේ)',
  ladingpageTips2: 'නව පරිශීලකයන් සඳහා පමණි!',
  Daily: 'දෛනික',
  dailyM: '179 Ks',
  Weekly: 'සතිපතා',
  weeklyM: '799 Ks',
  Monthly: 'මාසික',
  monthlyM: '3999 Ks',
  subscribeNow: 'දායක වන්න',
  Copyright: 'හිමිකම් © Grab&Get 2026',
  CopySucceeded: 'පිටපත් කිරීම සාර්ථකයි',
  play: 'මාව තෝරන්න',
  myAccount: 'පුද්ගලික තොරතුරු',
  profile: 'පැතිකඩ',
  FAQs: 'නිතර අසන ප්‍රශ්න',
  TC: 'නියමයන් සහ කොන්දේසි',
  language: 'භාෂාව',
  PickLanguage: 'භාෂාව තෝරන්න',
  Submit: 'යොමු කරන්න',
  change: 'වෙනස් කරන්න',
  English: 'ඉංග්‍රීසි',
  showMore: 'තවත් බලන්න',
  Login: 'ඇතුල් වන්න',
  Logout: 'පිටවන්න',
  getCode: 'නැවත යවන්න',
  phoneNumber: 'දුරකථන අංකය',
  enderNumber: 'දුරකථන අංකය ඇතුළත් කරන්න',
  Name: 'පරිශීලක නාමය',
  address: 'ලිපිනය',
  phone: 'දුරකථනය',
  Prize: 'ත්‍යාගය',
  referral: 'යොමු කිරීම',
  winnerList: 'ජයග්‍රාහක ලැයිස්තුව',
  Date: 'දිනය',
  Save: 'සුරකින්න',
  cancel: 'අවලංගු කරන්න',
  Confirm: 'තහවුරු කරන්න',
  goBack: 'ආපසු යන්න',
  No: 'නැත',
  OK: 'හරි',
  Yes: 'ඔව්',
  UNSUBSCRIBE: 'දායකත්වය අත්හරින්න',
  noMore: 'තවත් නැත',
  more: 'තවත්',
  ohNo: 'අයියෝ!',
  subDes2: 'ඔබ යාමට සූදානම් වීම අපට කනගාටුයි!',
  des2: 'ඔබට ඇත්තෙන්ම දායකත්වය අත්හැරීමට අවශ්‍යද?',
  boxes: 'මුළු ලකුණු',
  box: 'මුළු කාඩ්',
  referralTips1: 'නව පරිශීලකයෙකුට ආරාධනා කර ත්‍යාග ලබාගන්න. ආරාධනාකරුටත් ආරාධිතයාටත් ලකුණු 1000 බැගින් ලැබේ.',
  memberGetMember: 'සාමාජිකයාගෙන් සාමාජිකයා',
  referralTips2: 'මෙය ඔබගේ යොමු කිරීමේ ID ය',
  referralTips3: 'මෙය ඔබගේ මිතුරාගේ යොමු කිරීමේ ID ය',
  Status: 'තත්ත්වය',
  noFound: 'අපොයි! <br />ප්‍රතිඵල හමු නොවීය!',
  cgtips1: 'විශාල ත්‍යාගය ජයගන්න!!!',
  cgtips2: 'දෛනිකව 149ks පමණි,<br />දායක වීමට OK ක්ලික් කරන්න.',
  cgtips2W: 'සතිපතා 599ks පමණි,<br />දායක වීමට OK ක්ලික් කරන්න.',
  cgtips2M: 'මාසිකව 1999ks පමණි,<br />දායක වීමට OK ක්ලික් කරන්න.',
  indexbutton1: 'ක්‍රීඩාව තෝරන්න',
  getMorecards: 'තවත් ලකුණු ලබාගන්න',
  indexbutton2: 'වර 9ක් තෝරන්න',
  landFont1: 'දුරකථන අංකයක් ඇතුළත් කරන්න',
  landFont2: 'පැකේජය තෝරන්න',
  landingFont: 'දායක ගාස්තුව ප්‍රධාන ශේෂයෙන් අය කෙරේ.',
  optTips: 'ඔබ දැනටමත් දායක වී ඇත, ලොග් වීමේ කේතය ලබාගැනීමට OK ක්ලික් කරන්න',
  Invitation_Link: 'මෙය ඔබගේ ආරාධනා සබැඳිය',
  Copy: 'පිටපත් කරන්න',
  Invitation_Count: 'ආරාධනා ගණන',
  homeTotal1: 'ඔබගේ ක්‍රීඩා අවස්ථා',
  homefont2: 'විශාල ත්‍යාග ජයගැනීමට වාසනාවන්ත කාඩ් එකක් පෙරළන්න.',
  buyPack: 'පැකේජය මිලදී ගන්න',
  buyNow: 'දැන් මිලදී ගන්න',
  buyContent: 'ලකුණු වැඩි කරගැනීමට 1 ක්‍රීඩා අවස්ථාවක් සහිත පැකේජයක් මිලදී ගන්න',
  luckyTips1: 'එක් එක් කාඩ් එකෙන් පහත ත්‍යාග ජයගැනීමේ අවස්ථාව ඇත.',
  alertTips: 'ඔබ සාර්ථකව ආරාධනා කළ පරිශීලකයන්:',
  personalInfo: 'පුද්ගලික තොරතුරු',
  invitation_log: 'ආරාධනා ඉතිහාසය',
  ruleTask: 'කාර්ය නීති',
  DailyLogin: 'දෛනික ලොග් වීම',
  DailyLoginT1: 'දිනපතා ලොග් වී රසවත් ත්‍යාග අගුළු හැරගන්න!',
  Claim: 'ලබාගන්න',
  Missed: 'අහිමි විය',
  ReClaim: 'නැවත ලබාගන්න',
  DailyLoginT2: 'අහිමි වූ ත්‍යාග නැවත ලබාගන්න!',
  DailyLoginT3: '129 ks පමණි, අහිමි වූ ත්‍යාගය ලබාගත හැක.',
  yesClaim: 'ඔව්, ලබාගන්න',
  indexbutton12: 'සීමාවක් නැත!',
  game_list: 'කුඩා ක්‍රීඩා තෝරන්න',
  Play: 'ක්‍රීඩා කරන්න',
  Easy: 'පහසු',
  Medium: 'මධ්‍යම',
  Hard: 'අමාරු',
  Level: 'මට්ටම',
  ChooseTips1: 'මට්ටම 1, 2 හෝ 3 තෝරන්න.<br />ඉහළ මට්ටමක් නම් ජයගැනීමේ අවස්ථා වැඩිය!',
  total_starts: 'මුළු ලකුණු',

  Stars: 'ලකුණු',
  Ranking: 'ශ්‍රේණිගත කිරීම',
  Packs: 'පැකේජ',
  pkfont1: 'එක් වරක් පැකේජ',
  pkfont2: 'එක් වරක් මිලදී ගැනීම',
  pkfont3: 'තවත් 1 ක්‍රීඩා අවස්ථාව',
  pkfont4: '129 Ks',
  pkfont21: 'VIP රෝයල් කට්',
  pkfont22: 'දින 30ක් සඳහා',
  pkfont23: 'දිනකට ක්‍රීඩා අවස්ථා 5ක්, ලකුණු 200ක්, VIP ලාංඡනය සහ ෆ්‍රේම්',
  pkfont24: '3999 Ks',
  pkfont31: 'සතිපතා පැකේජ',
  pkfont32: 'සතියක් සඳහා',
  pkfont33: 'ක්‍රීඩා අවස්ථා 10ක්',
  pkfont34: '799 Ks',
  pkfont41: 'දෛනික පැකේජ',
  pkfont42: 'දෛනික දායකත්වය',
  pkfont43: 'දිනකට ක්‍රීඩා අවස්ථා 1ක්',
  pkfont44: '199 Ks',
  Yearly: 'වාර්ෂික',
  'Invitation successful!': 'ආරාධනය සාර්ථකයි!',
  invitTips1: 'නව පරිශීලකයෙකුට ආරාධනා කිරීමෙන් ඔබට ලකුණු 1000ක් ලැබී ඇත!',
  'Card Name': 'කාඩ් නාමය',
  'Thank You': 'ස්තුතියි',
  'no prize found': 'ත්‍යාගයක් හමු නොවීය',
  "Better luck next time!": 'මීළඟ වතාවේ වාසනාව!',
  LvL_1: 'මට්ටම 1',
  LvL_2: 'මට්ටම 2',
  LvL_3: 'මට්ටම 3',
  level_tip1: "'මට්ටම 1' කාඩ් එක 'ලකුණු 100' සමඟ පෙරළා විශාල ත්‍යාග දිනාගන්න.",
  level_tip2: "'මට්ටම 2' කාඩ් එක 'ලකුණු 200' සමඟ පෙරළා විශාල ත්‍යාග දිනාගන්න.",
  level_tip3: "'මට්ටම 3' කාඩ් එක 'ලකුණු 300' සමඟ පෙරළා විශාල ත්‍යාග දිනාගන්න.",
  indexbutton3: 'තවත් අවස්ථා මිලදී ගන්න',
  loginTips: 'දුරකථන අංකයක් ඇතුළත් කරන්න',
  upload_fail: 'උඩුගත කිරීම අසාර්ථකයි',
  home_prize_tip: 'ක්‍රීඩා කර වාසනාව උත්සාහ කර විශාල ත්‍යාග දිනාගන්න!',
  buy_popup_tip1: 'තවත් අවස්ථා මිලදී ගන්න',
  buy_popup_tip2: '129ks සමඟ තවත් ක්‍රීඩා අවස්ථා මිලදී ගැනීමට "දැන් මිලදී ගන්න" තට්ටු කරන්න',
  Guidance: 'මාර්ගෝපදේශය',
  Subscribe: 'දායක වන්න',
  DailyKyats: '149 කියාට්',
  WeeklyKyats: '599 කියාට්',
  OneTime: 'එක් වරක්',
  Purchase: 'මිලදී ගන්න',
  OneTimeChance: '129 Ks',
  lucky_draw: 'වාසනාවන්ත ඇදීම',
  yearly_list: 'වාර්ෂික ලැයිස්තුව',
  month_list: 'මාසික ලැයිස්තුව',
  week_list: 'සතිපතා ලැයිස්තුව',
  daily_tip: 'ප්‍රතිලාභ: ක්‍රීඩා අවස්ථා 2ක්',
  weekly_tip: 'ප්‍රතිලාභ:<br />පළමු දින ක්‍රීඩා අවස්ථා 4ක්<br />ඊළඟ දින 6 සඳහා දිනකට ක්‍රීඩා අවස්ථා 1ක්<br />මුළු: ක්‍රීඩා අවස්ථා 10ක්',
  monthly_tip: 'ප්‍රතිලාභ:<br />දිනකට ක්‍රීඩා අවස්ථා 5ක්<br />ලකුණු 200ක්<br />VIP රෝයල් ලාංඡනය<br />VIP විශේෂ පැතිකඩ ෆ්‍රේම් (දින 30ක් වලංගු)',
  buy_tip: 'ප්‍රතිලාභ: අවස්ථා 1ක්',
  daily_pack: 'දෛනික පැකේජය',
  weekly_pack: 'සතිපතා පැකේජය',
  monthly_pack: 'මාසික පැකේජය',
  one_time_package: 'එක් වරක් පැකේජය',
  sub_tip: 'සරලව ලියාපදිංචි වීමට<br />*615# අමතන්න හෝ HELP SMS 615ට යවන්න.<br />අත්හැරීමට OFF SMS 615ට යවන්න.<br />',
  GrabGet: 'Grab & Get',
  'Free Time': 'නොමිලේ කාලය',
  chance: 'අවස්ථා',
  goGet: 'ගෙන යන්න',
  join_us: '"615" මගින්ද අප සමඟ එක්විය හැක',
  avatar: 'අවතාරය'
}



// WEBPACK FOOTER //
// ./src/assets/i18n/bur.js